import React, { useState } from 'react';

import "assets/scss/components/buttons/toggle.scss";
import { isFunction } from 'functions';

function Toggle({
    isActiveInit,
    onStateChange = true,

    // Functions
    onToggle
}) {
    const [isActive, setIsActive] = useState(isActiveInit);

    function onActiveStateChange() {
        let newState = !isActive;
        if(onStateChange) {
            setIsActive(newState);
        }

        if (isFunction(onToggle)) onToggle(newState);
    }

    return (
        <div className={"component-toggle " +
                (isActive? "component-toggle_active":"")}
            onClick={onActiveStateChange}
        >
            <div className={"component-toggle__toggler " +
                    (isActive? "component-toggle__toggler_active ":"")}/>
        </div>
    );
}

export default Toggle;